'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReloadWarning = function ReloadWarning(_ref) {
  var authStore = _ref.authStore;

  if (!authStore.shouldShowReloadWarning) {
    return null;
  }
  var seconds = authStore.secondsUntilTokenExpires;
  return _react2.default.createElement(
    'div',
    { className: 'reload-warning animated fadeInDown' },
    _react2.default.createElement(
      'div',
      { className: 'inner' },
      _react2.default.createElement(
        'div',
        { className: 'text' },
        'As a security precaution, your session will expire in ',
        _react2.default.createElement(
          'strong',
          null,
          seconds,
          ' seconds'
        ),
        ', and you will have to log in again. Finish what you\'re doing and click the button below to reload.'
      ),
      _react2.default.createElement(
        'a',
        { className: 'button is-reload-button', onClick: function onClick() {
            return authStore.logout();
          } },
        'Reload now'
      )
    )
  );
};

ReloadWarning.propTypes = {
  authStore: _propTypes2.default.shape({
    shouldShowReloadWarning: _propTypes2.default.bool,
    secondsUntilTokenExpires: _propTypes2.default.number,
    logout: _propTypes2.default.func
  })
};

exports.default = (0, _mobxReact.observer)(ReloadWarning);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ReloadWarning/index.js
// module id = 623
// module chunks = 0